import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.availability');
import { OnInit, Input, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import ApexCharts from 'apexcharts';

@Component({
    selector: 'wiz-portal-kreonet-availability',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonet.availability/view.scss */
/* src/app/portal.kreonet.availability/view.scss: no such file or directory */`],
})
export class PortalKreonetAvailabilityComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public activeAvailabilityTab: any = "availability";
    public year: number = 2020;
    public years: any = [];
    public internal: any;
    public external: any;
    public internalcd: any = [];
    public externalcd: any = [];
    public values: any = [];
    public months: any = ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"];
    public selectedType = "internal";

    public showDetailModal: boolean = false;

    public exchangeNodes: any = [];

    // @ViewChild('chart')
    @ViewChild('chart', { static: false }) element!: ElementRef;
    public element: ElementRef;


    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        await this.loadNode();
        await this.loadAvail();
    }

    public async loadNode() {
        const { code, data } = await wiz.call("node");
        if (code != 200) return await this.service.alert.error("Error!");
        this.exchangeNodes = data;
        await this.service.render();
    }

    public async loadAvail() {
        const { code, data } = await wiz.call("availibility", { year: this.year });
        if (code != 200) return await this.service.alert.error("Error!");
        this.years = data.years;
        this.internal = data.internal;
        this.external = data.external;
        this.internalcd = data.internalcd;
        this.externalcd = data.externalcd;
        this.values = data.rows;

        await this.onTypeChange(this.selectedType);
    }

    public async tabChange(tab: any) {
        this.activeAvailabilityTab = tab;
        this.cdr.detectChanges();
        if (tab === 'availability') {
            await this.onTypeChange(this.selectedType);
        }
        await this.service.render();
    }

    public async onTypeChange(inex: string) {
        // if (!this.element) return;
        const isInternal = inex === "internal";
        await this.chartRender(this.element, [
            {
                name: isInternal ? "국내" : "국제",
                data: isInternal ? this.internalcd : this.externalcd
            }],
            this.months, isInternal ? "월별 국내 가용률" : "월별 국제 가용률"
        );

        await this.service.render();
    }

    public async loadChange(loading: boolean) {
        this.showDetailModal = loading;
        await this.service.render();
    }

    public async chartRender(element: any, series: any, category: any, title: any) {
        element.nativeElement.innerHTML = "";

        let options = {
            series: series,
            chart: {
                height: 245,
                type: 'area',
                sparkline: {
                    enabled: false
                },
                toolbar: {
                    show: false
                },
                animation: {
                    enabled: true,
                    dynamicAnimation: {
                        enabled: true
                    }
                },
                zoom: { enabled: false },
                parentHeightOffset: 0
            },
            grid: {
                padding: {
                    right: 0,
                    left: 0
                }
            },
            legend: {
                show: false
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 1
            },
            xaxis: {
                type: 'text',
                categories: category,
                labels: {
                    show: true, // x축 레이블 표시
                }
            },
            yaxis: {
                min: 0, max: 100,
                labels: {
                    show: true, // x축 레이블 표시
                    formatter: function (value: number) { // 레이블을 정수로 변환
                        return Math.round(value); // 소수점 없이 정수로 표시
                    }
                },
            },
            tooltip: {
                enabled: true,
                y: {
                    formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                        return Math.round(value * 100) / 100 + "%"
                    }
                }
            }
        };

        // if (title) {
        //     options.title = {
        //         text: title,
        //         offsetX: 24,
        //         style: {
        //             fontSize: '18px',
        //             cssClass: 'apexcharts-yaxis-title'
        //         }
        //     };
        // }

        let chart = new ApexCharts(element.nativeElement, options);
        chart.render();
    }
}

export default PortalKreonetAvailabilityComponent;